import React from 'react';
import '../styles/MissingComp.css';
import { Input } from '../components';

function MissingComp(props) {
    const address = props.address;
    const setAddress = props.setAddress;
    const missingCompDescription = props.missingCompDescription;
    const setMissingCompDescription = props.setMissingCompDescription;

    const onChangeAddress = (e) => {
        setAddress(e.target.value);
    };

    const onChangeDescription = (e) => {
        setMissingCompDescription(e.target.value);
    };

    return (
        <div className="missing-comp-modal-body">
            <Input
                label={"Missing comp address"}
                labelType={"default"}
                info={false}
                value={address}
                onChange={onChangeAddress}
                placeholder={"123 Main St, City, State, Zip"}
                type="text"
                leftUnit={null}
                rightUnit={null}
                unitSwitch={false}
                leftUnitSelected={true}
                unitSwitchFunc={null}
                disabled={false}
                multiline={false}
                error={false}
                onMouseEnter={null}
                onMouseLeave={null}
                reset={false}
                resetFunc={null}
                resetPosition={null}
                focusMultiline={false}
                prompt={false}
            />
            <Input
                label={"Missing comp description"}
                labelType={"default"}
                info={false}
                value={missingCompDescription}
                onChange={onChangeDescription}
                placeholder={"Tell us why this comp should be included."}
                type="text"
                leftUnit={null}
                rightUnit={null}
                unitSwitch={false}
                leftUnitSelected={true}
                unitSwitchFunc={null}
                disabled={false}
                multiline={true}
                error={false}
                onMouseEnter={null}
                onMouseLeave={null}
                reset={false}
                resetFunc={null}
                resetPosition={null}
                focusMultiline={false}
                prompt={false}
            />
        </div>
    )
};

export default MissingComp;